import { PlanContext, PlanContextProps } from 'data/plan/context';
import { useContext } from 'react';

export const usePlan = (): PlanContextProps => {
  return useContext(PlanContext);
};
